export default __webpack_public_path__ + "static/media/steps__slider-main-item-icon-little-3.33d7a218.svg";